// extracted by mini-css-extract-plugin
export default {"skillRadial":"skill_radial-module___skillRadial___f62f96dd","nameWrapper":"skill_radial-module___nameWrapper___a48aff7c","name":"skill_radial-module___name___e37489bf"};